import { ExportFormatCode } from '@/core/models/practice.models';
import { Button } from '@/kit/Button';
import { Icon } from '@/kit/Icon';

/** Direct Export to Excel / CSV / PDF icon buttons, used by the Accounts and Authorisation Codes grids. */
export function ExportMenu({ onExport }: { onExport: (format: ExportFormatCode) => void }) {
  return (
    <div className="toolbar">
      <Button title="Export to Excel" onClick={() => onExport(ExportFormatCode.Excel)}>
        <Icon name="border_all" className="icon-color-xls" />
      </Button>
      <Button title="Export to CSV" onClick={() => onExport(ExportFormatCode.Csv)}>
        <Icon name="description" outlined className="icon-color-xls" />
      </Button>
      <Button title="Export to PDF" onClick={() => onExport(ExportFormatCode.Pdf)}>
        <Icon name="picture_as_pdf" outlined className="icon-color-pdf" />
      </Button>
    </div>
  );
}
